import {ref, Ref} from '@vue/composition-api';

export type LinkIndex = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export interface LinkIndexInitLayoutData {
	linkIndex: LinkIndex;
}
// interface SetupLinkIndexProps {
// 	init_layout_data: LinkIndexInitLayoutData;
// }

export const AVAILABLE_LINK_INDEX_VALUES: LinkIndex[] = [1, 2, 3, 4, 5, 6, 7, 8];

function linkIndexPropValidator(value: number) {
	return AVAILABLE_LINK_INDEX_VALUES.includes(value as LinkIndex);
}
export const linkIndexProps = {
	linkIndex: {
		type: Number,
		validator: linkIndexPropValidator,
	},
};
export interface LinkIndexProps {
	linkIndex: LinkIndex;
}

export interface SetupLinkIndexReturn {
	linkIndex: Ref<LinkIndex>;
	onLinkIndexUpdate: (index: LinkIndex) => void;
	fromJSON(json: LinkIndexInitLayoutData): void;
	toJSON(): LinkIndexInitLayoutData;
}

export function SetupLinkIndex(initLinkIndex?: LinkIndex): SetupLinkIndexReturn {
	if (initLinkIndex == null) {
		initLinkIndex = AVAILABLE_LINK_INDEX_VALUES[0];
	}
	const linkIndex = ref(initLinkIndex);

	function fromJSON(json: LinkIndexInitLayoutData) {
		const newLinkIndex = json['linkIndex'];
		if (newLinkIndex != null) {
			linkIndex.value = newLinkIndex;
		}
	}
	function toJSON() {
		return {
			linkIndex: linkIndex.value,
		};
	}

	function onLinkIndexUpdate(index: LinkIndex) {
		linkIndex.value = index;
	}

	return {linkIndex, onLinkIndexUpdate, fromJSON, toJSON};
}
